<template>
    <KPL
        class="kpl-suspension jr-x-fixed-bottom-bar"
        :class="{'bottom-jdapp':isJdapp,'bottom-jdjr':isJdjr}"
        :url="jumpUrl"
        v-if="isOpenSource&&kplShow"
        :clstag="'jr|keycount|8530052_0110|'+jumpUrl"
    >
        <transition name="bottom-suspension">
            <div
                class="bottom-suspension"
                v-if="suspensionShow"
            >
                <img
                    alt="商品"
                    class="pic-suspension"
                    v-lazy="imgUrl"
                >
            </div>
        </transition>
    </KPL>
</template>
<script>
import KPL from '@/buscomponents/KPL';
import request from '@/util/request';
import { getStaticConfig, isMiniProgram } from '@/util/common';
export default {
    name: 'BottomSuspension',
    data() {
        return {
            isOpenSource: false,
            kplShow: false,
            suspensionShow: true,
            isJdapp: false,
            isJdjr: false,
            imgUrl: '',
            jumpUrl: '',
            status: '',
            topStart: '',
            topEnd: '',
            timer: null
        };
    },
    components: {
        KPL
    },
    props: {},
    created() {
        $(document).on('scroll', () => {
            this.isScroll();
        });
        this.isOpenSource = getStaticConfig('isOpenSource');
        this.suspension();
    },
    methods: {
        suspension() {
            // this.$loading.show();
            if (process.env.VUE_APP_ENV === 'minner' || process.env.VUE_APP_ENV === 'dev') {
                this.status = 0;
            } else {
                this.status = 1;
            }
            request.suspension({
                data: {},
                success: data => {
                    this.$loading.hide();
                    console.log($ && $.device);
                    if (data && data.suspension) {
                        if ((this.status == 0 && data.suspension.isOnline == 0) || (this.status == 1 && data.suspension.isOnline == 1)) {
                            this.imgUrl = data.suspension.imgUrl;
                            if ($.device && $.device.jdapp && data.suspension.jdappQd == 1) {
                                this.jumpUrl = data.suspension.jdappUrl;
                                this.kplShow = true;
                                this.isJdapp = true;
                            } else if ($.device && $.device.jdjr && data.suspension.jrappQd == 1) {
                                this.jumpUrl = data.suspension.jrappUrl;
                                this.kplShow = true;
                                this.isJdjr = true;
                            } else if ($.device && $.device.weixin && data.suspension.wqQd == 1) {
                                this.jumpUrl = data.suspension.wqUrl;
                                this.kplShow = true;
                                //微信和金融位置一样
                                this.isJdjr = true;
                            } else {
                                this.kplShow = false;
                            }
                        }
                    }
                },
                afterError: () => {}
            });
        },
        isScroll() {
            this.suspensionShow = false;
            clearTimeout(this.timer);
            this.timer = setTimeout(this.isScrollEnd, 500);
            this.topStart = document.documentElement.scrollTop || document.body.scrollTop;
        },
        isScrollEnd() {
            this.topEnd = document.documentElement.scrollTop || document.body.scrollTop;
            if (this.topEnd == this.topStart) {
                this.suspensionShow = true;
            }
        }
    },
    watch: {},
    mounted() {},
    destroyed() {
        this.$refs = null;
    }
};
</script>

<style lang="scss">
@import './../scss/mixin.scss';
.kpl-suspension {
    width: $rem150;
    height: $rem150;
    position: fixed;
    right: 0;
    bottom: $rem480;
    box-sizing: content-box;
}
.jr-x-fixed-bottom-bar {
    padding-bottom: constant(safe-area-inset-bottom) !important;
    padding-bottom: env(safe-area-inset-bottom) !important;
}
.jr-x-fixed-bottom-bar-inner {
    bottom: constant(safe-area-inset-bottom) !important;
    bottom: env(safe-area-inset-bottom) !important;
}

.jr-x-fixed-bottom-bar-inner::after {
    position: fixed;
    content: '';
    left: 0;
    bottom: 0;
    height: constant(safe-area-inset-bottom) !important;
    height: env(safe-area-inset-bottom) !important;
    width: 100%;
    z-index: 90;
    background-color: #fff;
}

.bottom-jdapp {
    bottom: $rem480;
}
.bottom-jdjr {
    bottom: $rem160;
}

.bottom-suspension {
    width: 100%;
    height: 100%;
    .pic-suspension {
        display: block;
        width: 100%;
        height: 100%;
    }
}
.bottom-suspension-enter-active,
.bottom-suspension-leave-active {
    transition: transform 0.5s ease-out;
}
.bottom-suspension-enter,
.bottom-suspension-leave-to {
    //开始过度和结束过度状态
    transform: translate3d(100%, 0, 0);
}
</style>
